var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',[_c('div',{attrs:{"id":"loadingTab"}},[_c('create-transfer',{ref:"CreateWithdrawal",attrs:{"selectedItem":_vm.selectedItem,"data":_vm.providerMethodList}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }